import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { handleRequestError } from 'Shared/utils/handle-request-error';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';
import FeedbackSchema from 'Shared/utils/normalizeJSON/schemas/Feedback.schema';
import { getFeedbackByUuid } from 'Shared/selectors/Feedbacks.selectors';
import FeedbacksConstants from 'Shared/constants/Feedbacks.constants';
import * as api from 'Shared/api/Feedbacks.api';

export const fetchFeedbacksSuccess = payload => ({
  type: FeedbacksConstants.Actions.FETCH_FEEDBACKS_SUCCESS,
  payload,
});

export const fetchSingleFeedbackSuccess = payload => ({
  type: FeedbacksConstants.Actions.FETCH_SINGLE_FEEDBACK_SUCCESS,
  payload,
});

export const createFeedbackRequest = payload => ({
  type: FeedbacksConstants.Actions.CREATE_FEEDBACK_REQUEST,
  payload,
});

export const createFeedbackSuccess = payload => ({
  type: FeedbacksConstants.Actions.CREATE_FEEDBACK_SUCCESS,
  payload,
});

export const updateFeedbackRequest = payload => ({
  type: FeedbacksConstants.Actions.UPDATE_FEEDBACK_REQUEST,
  payload,
});

export const updateFeedbackSuccess = payload => ({
  type: FeedbacksConstants.Actions.UPDATE_FEEDBACK_SUCCESS,
  payload,
});

export const updateFeedbackFailure = payload => ({
  type: FeedbacksConstants.Actions.UPDATE_FEEDBACK_FAILURE,
  payload,
});

export const destroyFeedbackRequest = payload => ({
  type: FeedbacksConstants.Actions.DESTROY_FEEDBACK_REQUEST,
  payload,
});

export const destroyFeedbackFailure = payload => ({
  type: FeedbacksConstants.Actions.DESTROY_FEEDBACK_FAILURE,
  payload,
});

export const viewFeedbackSuccess = payload => ({
  type: FeedbacksConstants.Actions.VIEW_FEEDBACK_SUCCESS,
  payload,
});

export const feedbacksSyncSuccess = payload => ({
  type: FeedbacksConstants.Actions.FEEDBACKS_SYNC_SUCCESS,
  payload,
});

export const fetchAISuggesstionsSuccess = payload => ({
  type: FeedbacksConstants.Actions.FEEDBACKS_FETCH_AI_SUGGESSTIONS_SUCCESS,
  payload,
});

export const fetchFeedbacks = params => dispatch => {
  return handleRequestError(api.fetchFeedbacks(params))
    .then(response => {
      dispatch(fetchFeedbacksSuccess(normalizer(FeedbackSchema, response.data)));
      return { count: response.data.feedbacks_count, feedbacks: response.data.data };
    })
    .catch(e => WpToastManager.danger(e.message));
};

export const fetchFeedbackDrafts =
  ({ limit, offset, workspaceSlug } = {}) =>
  dispatch => {
    return handleRequestError(api.fetchFeedbackDrafts({ limit, offset, workspaceSlug }))
      .then(response => {
        dispatch(fetchFeedbacksSuccess(normalizer(FeedbackSchema, response.data)));
        return response;
      })
      .catch(e => WpToastManager.danger(e.message));
  };

export const fetchSingleFeedback = uuid => dispatch => {
  return handleRequestError(api.fetchSingleFeedback(uuid))
    .then(response => {
      dispatch(fetchSingleFeedbackSuccess(normalizer(FeedbackSchema, response.data)));
      return response.data;
    })
    .catch(e => WpToastManager.danger(e.message));
};

export const createFeedback = feedback => dispatch => {
  return api
    .createFeedback(feedback)
    .then(response => {
      dispatch(createFeedbackSuccess(normalizer(FeedbackSchema, response.data)));
      WpToastManager.success('Created');
      return response;
    })
    .catch(e => {
      WpToastManager.danger('Error creating feedback.');
      return e;
    });
};

export const updateFeedback = data => (dispatch, getState) => {
  const feedback = getFeedbackByUuid(data.uuid)(getState());
  dispatch(updateFeedbackRequest(data));
  return handleRequestError(api.updateFeedback(data))
    .then(response => {
      dispatch(updateFeedbackSuccess(normalizer(FeedbackSchema, response.data)));
      WpToastManager.success('Success');
      return response;
    })
    .catch(e => {
      dispatch(updateFeedbackFailure(feedback));
      WpToastManager.danger(e.message);
    });
};

export const destroyFeedback = uuid => (dispatch, getState) => {
  const feedback = getFeedbackByUuid(uuid)(getState());
  dispatch(destroyFeedbackRequest(uuid));
  return handleRequestError(api.destroyFeedback(uuid)).catch(e => {
    dispatch(destroyFeedbackFailure(feedback));
    WpToastManager.danger(e.message);
  });
};

export const viewFeedback = uuid => async dispatch => {
  return api
    .viewFeedback({ uuid })
    .then(response => dispatch(viewFeedbackSuccess(normalizer(FeedbackSchema, response.data))));
};

export const fetchAIFeedbackSuggestions = data => dispatch => {
  return api.fetchAIFeedbackSuggestions(data).then(response => {
    dispatch(fetchAISuggesstionsSuccess(response));
    return response;
  });
};
